import React from 'react';
import {RichText} from 'prismic-reactjs';

export const BlockQuote = ({slice}) => (
  <blockquote>
    <RichText render={slice.primary.quote}/>
  </blockquote>
);